import { render, staticRenderFns } from "./SummaryCardSection.vue?vue&type=template&id=4deaa5f3&scoped=true&"
import script from "./SummaryCardSection.vue?vue&type=script&setup=true&lang=js&"
export * from "./SummaryCardSection.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SummaryCardSection.vue?vue&type=style&index=0&id=4deaa5f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4deaa5f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4deaa5f3')) {
      api.createRecord('4deaa5f3', component.options)
    } else {
      api.reload('4deaa5f3', component.options)
    }
    module.hot.accept("./SummaryCardSection.vue?vue&type=template&id=4deaa5f3&scoped=true&", function () {
      api.rerender('4deaa5f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Trips/Components/SummaryCardSection.vue"
export default component.exports